import environment from './environment.app';

export default () => environment() === 'production';
